import { storeToRefs } from 'pinia';
import type { WebformModalState } from '~~/types/vuex/WebformModal';
import { webformModalStore } from '~/stores/webformModal';

export default function () {

  const store = webformModalStore();
  const { webformState } = storeToRefs(store);

  const isWebformModalOpen = computed(() => store.webformState !== null);

  function openWebformModal(params?: WebformModalState['webformState']) {

    store.setWebformState(params || {});
  
  }

  function closeWebformModal() {

    store.setWebformState(null);
  
  }

  return {
    ...store,
    isWebformModalOpen,
    webformState,
    openWebformModal,
    closeWebformModal,
  };

}